import { Inject, Injectable } from '@angular/core'
import { Location } from '@angular/common'
import { BreadcrumbsService } from '../../../core/services/breadcrumbs.service'
import { ProjectService } from '../../auth/project.service'
import { NotificationControllerService } from '../../../api/backend'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'
import { Observable } from 'rxjs'
import { CaStateService } from '../../../core/services/ca-state.service'
import { Store } from '@ngrx/store'
import { MainViewActions } from '../state/action-types'
import { EXPIRATION_DATE_QUERY_PARAM, FINISHED_NOTIFICATION_FILTER } from '../../../constants/finished-notification-filter.constant'

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(@Inject(Store) private store: Store,
                @Inject(BreadcrumbsService) private breadcrumbsService: BreadcrumbsService,
                @Inject(NotificationControllerService) private notificationControllerService: NotificationControllerService,
                @Inject(ProjectService) private projectservice: ProjectService,
                @Inject(CaStateService) private caStateService: CaStateService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                @Inject(Location) private location: Location) {
    }

    commonNotificationDetail(item): void {
        this.store.dispatch(MainViewActions.setNotificationDetail({
            detail: item
        }))
    }

    contractNotificationDetail(notification): void {
        if (notification.notification.contractId) {
            this.breadcrumbsService.deleteAllBreadcrumbs()
            this.caStateService.setContractShowState(notification.notification.contractId)
        } else if (notification.notification.contractInvalidDate) {
            const expirationDate = notification.notification.contractInvalidDate

            this.breadcrumbsService.deleteAllBreadcrumbs()
            // resetFilter jako u dlaždic z LP: effect seznamu smaže kritéria uložená pro pojmenovaný
            // filtr (klíč `-filteredFilterCriteriaStorageKey`) a cache seznamu, aby proklik ukázal čistě
            // to, co notifikace slibuje. Ručně uložený filtr plain seznamu (`-contractsFilterCriteria`) zůstává.
            this.caStateService.setContractListState({
                [EXPIRATION_DATE_QUERY_PARAM]: expirationDate,
                setFilter: FINISHED_NOTIFICATION_FILTER,
                resetFilter: true,
            })
        }
    }

    getClass(notification): string {
        switch (notification.notification.notificationType) {
            case 'CONTRACT':
                return 'fa-calendar-o'
            case 'INFO':
                return 'fa-envelope-o'
            case 'PERSONAL_DATA':
                return 'fa-download'
            case 'ESIGN':
                return 'fa-paper-plane-o'
            default:
                return 'fa-envelope-o'
        }
    }

    paymentNotificationDetail(): void {
        if (!this.caStateService.isPaymentsState() && this.projectservice.isContractPayment()) {
            this.caStateService.setPaymentsState()
        } else {
            window.location.reload()
        }
    }

    read(notificationId: number): Observable<any> {
        return this.notificationControllerService.readNotification(
            this.authContextStorageService.getProjectKey(),
            notificationId
        )
    }

    readAll(): Observable<any> {
        return this.notificationControllerService.readAll(
            this.authContextStorageService.getProjectKey()
        )
    }
}
